// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var InviteAcceptBodyPhase = function (x) {
    return x;
};
var tsBridgeInviteAcceptBodyP = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeIntersection([ new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("ready"), new DTS_Types.TsTypeTypelevelString("missingToken") ]), new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("__brandInviteAcceptBodyPhase", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString("InviteAcceptBodyPhase")) ]) ]));
    }
};
var showInviteAcceptBodyPhase = Data_Show.showString;
var ordInviteAcceptBodyPhase = Data_Ord.ordString;
var inviteAcceptBodyPhaseToString = function (v) {
    return v;
};
var writeInviteAcceptBodyPhase = {
    writeImpl: /* #__PURE__ */ (function () {
        var $19 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($20) {
            return $19(inviteAcceptBodyPhaseToString($20));
        };
    })()
};
var inviteAcceptBodyPhaseReady = "ready";
var inviteAcceptBodyPhaseMissingToken = "missingToken";
var inviteAcceptBodyPhaseNamespace = {
    ready: inviteAcceptBodyPhaseReady,
    missingToken: inviteAcceptBodyPhaseMissingToken
};
var inviteAcceptBodyPhaseFromString = function (value) {
    if (value === "ready") {
        return new Data_Maybe.Just(inviteAcceptBodyPhaseReady);
    };
    if (value === "missingToken") {
        return new Data_Maybe.Just(inviteAcceptBodyPhaseMissingToken);
    };
    return Data_Maybe.Nothing.value;
};
var readInviteAcceptBodyPhase = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = inviteAcceptBodyPhaseFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid InviteAcceptBodyPhase: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Ui.InviteAcceptBodyPhase (line 54, column 5 - line 56, column 88): " + [ v.constructor.name ]);
        });
    }
};
var eqInviteAcceptBodyPhase = Data_Eq.eqString;
export {
    inviteAcceptBodyPhaseReady,
    inviteAcceptBodyPhaseMissingToken,
    inviteAcceptBodyPhaseNamespace,
    inviteAcceptBodyPhaseFromString,
    inviteAcceptBodyPhaseToString,
    eqInviteAcceptBodyPhase,
    ordInviteAcceptBodyPhase,
    showInviteAcceptBodyPhase,
    readInviteAcceptBodyPhase,
    writeInviteAcceptBodyPhase,
    tsBridgeInviteAcceptBodyP
};
//# sourceMappingURL=index.js.map
